import React from 'react';
import Table from '../../components/common/Table';
import { renderBooleanBadge } from '../../utils/displayUtils';
import { FirearmTypeDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface FirearmTypeTableProps {
  data: FirearmTypeDTO[];
  handleEdit: (row: FirearmTypeDTO) => void;
  handleDelete: (row: FirearmTypeDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const FirearmTypeTable: React.FC<FirearmTypeTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                {
          label: "Title",
          key: "title",
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: FirearmTypeDTO) => renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: "Position",
          key: "displayPosition",
        },
        {
          label: "Added",
          key: "createdUtc",
          format: (createdUtc: Date) => convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default FirearmTypeTable;
